import React, { useState, useEffect } from "react"
import API from "../../api/axios"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { Navigate, useLocation, useNavigate } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"
import { useSelector, useDispatch } from "react-redux"
import { fetchLeaveDays } from "../../store/clinicSetting/action"
import DeleteModel from "./DeleteModel"
const LeaveProfile = () => {
  document.title = "Edit Leave | Dashboard"

  const location = useLocation()
  const navigate = useNavigate()
  const [leaveData, setLeaveData] = useState(location.state?.leaveData || {})
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredUsers, setFilteredUsers] = useState([])
  const [leaveDays, setLeaveDays] = useState(0)
  const [leaveList, setLeaveList] = useState("")
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: leaveData?.id || "",
      user_id: leaveData?.user_id || "",
      leave_startDate: leaveData?.leave_startDate || "",
      leave_endDate: leaveData?.leave_endDate || "",
      status: leaveData?.status || "",
      remark: leaveData?.remark || "",
    },
    validationSchema: Yup.object({
      user_id: Yup.string().required("User ID is required"),
      leave_startDate: Yup.date().required("Start date is required"),
      leave_endDate: Yup.date()
        .min(Yup.ref("leave_startDate"), "End date can't be before start date")
        .required("End date is required"),
      status: Yup.string().required("Status is required"),
      remark: Yup.string(),
    }),
    onSubmit: async values => {
      await updateLeave(values)
    },
  })
  const dispatch = useDispatch()
  const closedDays = useSelector(state => state.clinicSetting?.leaveDays) || []

  console.log("closedDays", closedDays)

  useEffect(() => {
    dispatch(fetchLeaveDays())
  }, [dispatch])

  useEffect(() => {
    if (validation.values.leave_startDate && validation.values.leave_endDate) {
      const start = new Date(validation.values.leave_startDate)
      const end = new Date(validation.values.leave_endDate)

      // Calculate the total number of days between start and end date (inclusive)
      const timeDiff = end - start
      let totalDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1

      // Map of days of the week, where 0 is Sunday, 1 is Monday, etc.
      const daysOfWeek = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ]

      // Exclude closed days (holidays or non-working days) from leave days
      let actualLeaveDays = totalDays

      // Loop through each day in the date range and exclude closed days
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dayOfWeek = daysOfWeek[d.getDay()].toLowerCase() // Get the day of the week as a string (e.g., 'sunday')

        // Check if this day is in the closedDays array
        if (closedDays.includes(dayOfWeek)) {
          actualLeaveDays -= 1 // Decrease leave days for each closed day
        }
      }

      // Update the state with the calculated leave days excluding closed days
      setLeaveDays(actualLeaveDays)
    }
  }, [
    validation.values.leave_startDate,
    validation.values.leave_endDate,
    closedDays,
  ])

  useEffect(() => {
    const fetchLeaves = async () => {
      const authToken = localStorage.getItem("authToken")
      const res = await API.get("/leaves", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      const leaves = res.data

      const updatedLeaves = await Promise.all(
        leaves.map(async leave => {
          try {
            const authToken = localStorage.getItem("authToken")
            const userRes = await API.get(
              `/users/${leave.user_id}`,
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                  "Content-Type": "application/json",
                },
              },
            )
            const user = userRes.data.user
            return {
              ...leave,
              userName: `${user.fname} ${user.lname}`,
            }
          } catch {
            return { ...leave, userName: "Unknown User" }
          }
        }),
      )

      setLeaveList(updatedLeaves)
    }

    fetchLeaves()
  }, [])

  const handleDelete = () => {
    if (!leaveData || !leaveData.id) {
      toast.error("Invalid user data.")
      return
    }
    setShowDeleteModal(true) // open modal
  }

  const confirmDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.delete(
        `/leaves/${leaveData.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("leave deleted successfully!", { autoClose: 2000 })
        setShowDeleteModal(false)
        navigate("/leave")
      } else {
        toast.error("Failed to delete leave. Please try again.")
      }
    } catch (error) {
      console.error("Error deleting leave:", error)
      toast.error("Error deleting leave.")
    }
  }

 
  const updateLeave = async updatedData => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await API.put(
        `/leaves/${updatedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "application/json",
          },
        },
      )

      // https://doc-bknd.ixorainnovation.com/api
      console.log("updated response", response.data)

      if (response.status === 200) {
        toast.success("Leave updated successfully", { autoClose: 2000 })
        setTimeout(() => navigate("/leave"), 2000)
      } else {
        toast.error("Failed to update leave. Please try again.")
      }
    } catch (error) {
      console.error("Error updating leave:", error)
      toast.error("Error updating leave.")
    }
  }
  // Fetching the user name based on user_id
  useEffect(() => {
    if (leaveData?.user_id) {
      const fetchUserName = async () => {
        try {
          const authToken = localStorage.getItem("authToken")

          const userRes = await API.get(
            `/users/${leaveData.user_id}`,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          const user = userRes.data.user
          setSearchTerm(`${user.fname} ${user.lname}`)
        } catch (error) {
          console.error("Error fetching user:", error)
        }
      }
      fetchUserName()
    }
  }, [leaveData?.user_id])

  const handleSearchChange = async e => {
    const query = e.target.value
    setSearchTerm(query)

    if (!query.trim()) {
      setFilteredUsers([])
      return
    }

    try {
      const response = await API.get(
        `/users/demo/search?search=${query}`,
      )
      setFilteredUsers(response.data.users || [])
    } catch (err) {
      console.error("Search error:", err)
    }
  }

  const handleUserClick = user => {
    validation.setFieldValue("user_id", user.id)
    setSearchTerm(`${user.fname} ${user.lname}`)
    setFilteredUsers([])
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content p-0">
        <Container fluid>
          <h4 className="card-title mb-4">Edit Leave</h4>

          <Card>
            <CardBody>
              <form
                className="form-horizontal"
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col md="4">
                    <Label>Leave Start Date</Label>
                    <Input
                      type="date"
                      name="leave_startDate"
                      value={validation.values.leave_startDate}
                      onChange={validation.handleChange}
                    />
                    {validation.errors.leave_startDate &&
                      validation.touched.leave_startDate && (
                        <div className="text-danger">
                          {validation.errors.leave_startDate}
                        </div>
                      )}
                  </Col>

                  <Col md="4">
                    <Label>Leave End Date</Label>
                    <Input
                      type="date"
                      name="leave_endDate"
                      value={validation.values.leave_endDate}
                      onChange={validation.handleChange}
                    />
                    {validation.errors.leave_endDate &&
                      validation.touched.leave_endDate && (
                        <div className="text-danger">
                          {validation.errors.leave_endDate}
                        </div>
                      )}
                  </Col>

                  {/* <Row className="mt-3"> */}
                  <Col md="4">
                    <Label>No. of Leave Days</Label>
                    <Input type="number" value={leaveDays} disabled />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      name="status"
                      value={validation.values.status}
                      onChange={validation.handleChange}
                    >
                      <option value="">Select Status</option>
                      <option value="enabled">Enabled</option>
                      <option value="disabled">Disabled</option>
                    </Input>
                    {validation.errors.status && validation.touched.status && (
                      <div className="text-danger">
                        {validation.errors.status}
                      </div>
                    )}
                  </Col>

                  <Col md="4">
                    <Label>Remark</Label>
                    <Input
                      type="textarea"
                      name="remark"
                      value={validation.values.remark}
                      onChange={validation.handleChange}
                    />
                  </Col>
                </Row>

                <div
                  className="text-center mt-4"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContet: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    className="px-3 border"
                    disabled={validation.isSubmitting}
                  >
                    Update Leave
                  </Button>
                  <Button
                    type="button"
                    color="danger"
                    className="px-3 border"
                    onClick={handleDelete}
                  >
                    Delete leave
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    className="px-3 border"
                    onClick={() => navigate("/leave")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>
        <DeleteModel
        isOpen={showDeleteModal}
          toggle={() => setShowDeleteModal(false)}
          entityName="leave"
          entityLabel={leaveData?.name}
          onConfirm={confirmDelete}/>
      </div>
    </React.Fragment>
  )
}

export default LeaveProfile
